var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIosIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.895 18.1575C14.7518 19.2656 13.5036 19.0907 12.3021 18.5657C11.0306 18.0291 9.86406 18.0058 8.52256 18.5657C6.84277 19.289 5.95622 19.079 4.95301 18.1575C-0.739606 12.2899 0.100289 3.35432 6.56281 3.0277C8.13761 3.10935 9.23414 3.89092 10.1557 3.96091C11.5322 3.68095 12.8503 2.87605 14.3202 2.98104C16.0816 3.12102 17.4114 3.82093 18.2863 5.08077C14.6468 7.26216 15.51 12.0566 18.8463 13.3981C18.1813 15.1478 17.3181 16.886 15.8833 18.1691L15.895 18.1575ZM10.039 2.95771C9.86406 0.356369 11.9755 -1.79003 14.4018 -2C14.7401 1.00962 11.6722 3.24934 10.039 2.95771Z",
    fill: "#8795B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/ios-icon.023ea522436d12ab89afa6679550a262.svg";
export { ForwardRef as ReactComponent };